import React, { Component } from 'react';
import AuthContext from '../AuthContext';
import { Navigate, Outlet } from "react-router-dom";

export class ControlPanel extends Component {
    static contextType = AuthContext;

    componentDidMount() {
        this.context.toggleLoginModal(true);
    }

    render() {
        const { isAuthenticated } = this.context;
        if (!isAuthenticated) {
            localStorage.setItem("redirectUrl", window.location.pathname);
        }
        return (
            <div className="min-h-full">
                {isAuthenticated && <Outlet />}
            </div>
        );
    }
}